module.exports = __webpack_public_path__ + "img/two2Orange.e6ed1bf3.png";